import common from '../common';
import Text from '../ui/Text';
import Scene from './Scene';
import { texture } from 'p3';

export default class PreloaderScene extends Scene {
	constructor() {
		super();

		this.loaded = 0;
		this._loadingBar = null;
	}

	init() {
		super.init();

		const bg = new PIXI.Sprite(texture('preloader_bg'));

		bg.anchor.set(0.5);
		bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
		bg.width = 1800 * P3.View.zoom * 1.25;
		bg.height = 768 * P3.View.zoom * 1.25;
		this.addChild(bg);

		const loadingbg = new PIXI.Sprite(texture('loading_bg'));

		loadingbg.scale.set(0.25);
		loadingbg.anchor.set(0.5);
		loadingbg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - 70);
		this.addChild(loadingbg);

		this._loadingBar = new PIXI.Sprite(texture('loading_fill'));
		this._loadingBar.scale.set(0.25);
		this._loadingBar.anchor.set(0.5);
		this._loadingBar.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - 70);
		this.addChild(this._loadingBar);

		this._loadingMask = new PIXI.Graphics();
		this._loadingMask.beginFill(0xFF0000, 0.6);
		this._loadingMask.drawRect(this._loadingBar.x - this._loadingBar.width * 1.5, this._loadingBar.y - this._loadingBar.height * 0.5, this._loadingBar.width, this._loadingBar.height);
		this._loadingMask.endFill();
		this.addChild(this._loadingMask);
		this._loadingBar.mask = this._loadingMask;

		const loadingtext = new Text('gui.preloader', { font: '28px', align: 'left', tint: 0xFFFFFF });

		loadingtext.anchor.set(0.5);
		loadingtext.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT - 100);
		this.addChild(loadingtext);

		const counters = this._createTextCounters();

		counters.position.set(this._loadingBar.x - this._loadingBar.width * 0.5, this._loadingBar.y);
		this.addChild(counters);
	}

	_createTextCounters() {
		const counters = new PIXI.Container();

		counters.value0 = new Text('0', { font: '28px', align: 'left', tint: 0xFFFFFF });
		counters.value0.anchor.set(0.5, 0);
		counters.value0.position.set(counters.x + 5, counters.y + 10);
		counters.addChild(counters.value0);

		counters.value25 = new Text('25', { font: '28px', align: 'left', tint: 0xFFFFFF });
		counters.value25.anchor.set(0.5, 0);
		counters.value25.position.set(counters.x + this._loadingBar.width * 0.25, counters.y + 10);
		counters.addChild(counters.value25);

		counters.value50 = new Text('50', { font: '28px', align: 'left', tint: 0xFFFFFF });
		counters.value50.anchor.set(0.5, 0);
		counters.value50.position.set(counters.x + this._loadingBar.width * 0.5, counters.y + 10);
		counters.addChild(counters.value50);

		counters.value75 = new Text('75', { font: '28px', align: 'left', tint: 0xFFFFFF });
		counters.value75.anchor.set(0.5, 0);
		counters.value75.position.set(counters.x + this._loadingBar.width * 0.75, counters.y + 10);
		counters.addChild(counters.value75);

		counters.value100 = new Text('100', { font: '28px', align: 'left', tint: 0xFFFFFF });
		counters.value100.anchor.set(0.5, 0);
		counters.value100.position.set(counters.x + this._loadingBar.width - 4, counters.y + 10);
		counters.addChild(counters.value100);

		return counters;
	}

	destroy() {
		// clean up goes here
		super.destroy();
	}

	update() {
		this._loadingMask.x = this._loadingBar.width * this.loaded;
	}
}
